import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { clearData, loadData, nextQuestion, storeResponseInAttempts } from '../../actions.js';
import { clearDisplayMessageAndError } from '../../actions/display';
import massEditActions from '../../actions/massEdit';
import {
  massEditDeleteResponses,
  submitMassEditConceptResults,
  submitMassEditFeedback
} from '../../actions/responses';
import { FillInBlankQuestion, TestFillInBlankQuestionContainer } from '../../../Shared';
import PlayFillInTheBlankQuestion from '../studentLessons/fillInBlank.tsx';
import ResponseComponentWrapper from '../questions/responseRouteWrapper.jsx';

const ConnectTestComponent = ({ conceptsFeedback, dispatch, fillInBlank, match, playLesson, }) => {
  const testQuestionID = match.params.questionID;
  const testQuestion = fillInBlank?.data?.[testQuestionID];
  const { currentQuestion } = playLesson || {};

  return (
    <TestFillInBlankQuestionContainer
      actions={{
        clearData,
        loadData,
        nextQuestion,
        storeResponseInAttempts
      }}
      conceptsFeedback={conceptsFeedback}
      currentQuestion={currentQuestion ? currentQuestion.question : null}
      dispatch={dispatch}
      PlayComponent={PlayFillInTheBlankQuestion}
      question={testQuestion}
      questionID={testQuestionID}
      questionKey="question"
    />
  );
}

const FillInBlankQuestionContainer = ({ conceptsFeedback, dispatch, display, fillInBlank, massEdit, match, playLesson }) => {
  const { questionID } = match.params;
  const question = fillInBlank ? fillInBlank.data[questionID] : null;

  return (
    <FillInBlankQuestion
      actions={{
        clearDisplayMessage: clearDisplayMessageAndError,
        clearResponses: massEditActions.clearResponsesFromMassEditArray,
        deleteAll: massEditDeleteResponses,
        removeResponse: massEditActions.removeResponseFromMassEditArray,
        submitConceptResults: submitMassEditConceptResults,
        submitFeedback: submitMassEditFeedback
      }}
      basePath="fill-in-the-blanks"
      dispatch={dispatch}
      displayError={display?.error}
      displayMessage={display?.message}
      hasReceivedData={fillInBlank.hasreceiveddata}
      massEdit={massEdit}
      question={question}
      questionID={questionID}
      ResponseComponent={ResponseComponentWrapper}
      TestComponent={(routeProps) => (
        <ConnectTestComponent
          {...routeProps}
          conceptsFeedback={conceptsFeedback}
          dispatch={dispatch}
          fillInBlank={fillInBlank}
          playLesson={playLesson}
        />
      )}
      useRelativePaths={true}
    />
  );
}

function select(props) {
  return {
    conceptsFeedback: props.conceptsFeedback,
    display: props.display,
    fillInBlank: props.fillInBlank,
    massEdit: props.massEdit,
    playLesson: props.playLesson
  };
}

export default withRouter(connect(select)(FillInBlankQuestionContainer));
